module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topicDetail"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("话题管理 > 查看详情\n\t\t"), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.noIssue
    }
  }, [_vm._v("撤销发布")])], 1), _vm._v(" "), _c('div', {
    staticClass: "topicNum"
  }, [_c('div', {
    staticClass: "commentNum"
  }, [_vm._v("评论数：" + _vm._s(_vm.topicForm.commentNum))]), _vm._v(" "), _c('div', {
    staticClass: "participateNum"
  }, [_vm._v("参与人：" + _vm._s(_vm.topicForm.participateNum))])]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('el-form', {
    ref: "articleForm",
    attrs: {
      "model": _vm.topicForm,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "封面图片"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "325px",
      "height": "125px"
    },
    attrs: {
      "src": _vm.topicForm.coverUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "详情页图片"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "325px",
      "height": "125px"
    },
    attrs: {
      "src": _vm.topicForm.detailUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-form-item', {
    staticClass: "topicTitle",
    attrs: {
      "label": "话题名称"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.topicForm.title),
      callback: function($$v) {
        _vm.$set(_vm.topicForm, "title", $$v)
      },
      expression: "topicForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "topicAbstract",
    attrs: {
      "label": "摘要"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 5
      },
      "disabled": ""
    },
    model: {
      value: (_vm.topicForm.abstract),
      callback: function($$v) {
        _vm.$set(_vm.topicForm, "abstract", $$v)
      },
      expression: "topicForm.abstract"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "articleType",
    attrs: {
      "label": "类别"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.topicForm.type),
      callback: function($$v) {
        _vm.$set(_vm.topicForm, "type", $$v)
      },
      expression: "topicForm.type"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "initParticipateNum",
    attrs: {
      "label": "初始参与数"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.topicForm.initParticipateNum),
      callback: function($$v) {
        _vm.$set(_vm.topicForm, "initParticipateNum", $$v)
      },
      expression: "topicForm.initParticipateNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-checkbox', {
    staticClass: "radio",
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.topicForm.ifNotice),
      callback: function($$v) {
        _vm.$set(_vm.topicForm, "ifNotice", $$v)
      },
      expression: "topicForm.ifNotice"
    }
  }, [_vm._v("首次发布，向所有用户发送更新通知")])], 1), _vm._v(" "), _c('select-school', {
    attrs: {
      "schObj": _vm.topicForm.schObj,
      "canUse": _vm.canUse
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-eacd4a2a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/topic/topicDetail.vue
// module id = 1138
// module chunks = 0